<template>
  <div>
    <!-----选择---->
    <el-button
      type="primary"
      size="mini"
      plain
      class="m-r-6"
      @click="openCertificateRequire()"
    ><i class="el-icon-plus m-r-2"></i>添加</el-button>
    <slot>
      <div style="display: inline-block">
        <el-tag
          v-for="(tag, index) in certList"
          :key="tag.id"
          size="medium"
          effect="plain"
          type="info"
          class="m-b-4 m-r-6"
          closable
          @close="closeCertListTag(index)"
        >
          {{ tag[props.name] }}
        </el-tag>
      </div>
    </slot>

    <!-----dialog----->
    <el-dialog
      class="dialog dialog-table"
      width="760px"
      title="选择证件"
      :visible="visible"
      :close-on-press-escape="true"
      :close-on-click-modal="false"
      :before-close="closeDialog"
    >
      <!--------选中项----------->
      <div class="m-b-10">
        <el-tag
          v-for="(tag, index) in selection"
          :key="tag.id"
          class="m-t-10 m-l-10"
          size="medium"
          closable
          @close="closeTag(index)"
        >
          {{ tag.name }}
        </el-tag>
      </div>

      <!-- 列表 -->
      <div class="sort-container">
        <!-- 证件分类 -->
        <div class="content-left card">
          <div class="section">
            <div class="section-content">
              <el-input
                v-model="sortSearchText"
                placeholder="请输入证书分类名称"
                size="small"
                clearable
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <el-tree
                ref="tree"
                :data="sortList"
                :props="{ label: 'name', children: 'children' }"
                default-expand-all
                :filter-node-method="filterNode"
                @node-click="selectSort"
              >
                <div
                  slot-scope="{ node }"
                  class="text-ellipsis"
                  :title="`${node.data.name}`"
                  :class="{ active: currentSortId === node.data.id }"
                >
                  {{ node.data.name }}
                </div>
              </el-tree>
            </div>
          </div>
        </div>

        <!----分类搜索------->
        <div class="content-right">
          <!-- 搜索表单 -->
          <el-form
            :model="filterForm"
            :inline="true"
            label-suffix="："
            size="small"
          >
            <el-form-item label="">
              <el-input
                v-model.trim="filterForm.name"
                placeholder="请输入证件名称"
              />
            </el-form-item>

            <el-form-item>
              <el-button
                :disabled="!currentSortId"
                size="small"
                type="primary"
                @click="handleSearch"
              >
                查询
              </el-button>
            </el-form-item>
          </el-form>

          <!-- 搜索结果 -->
          <jczh-table-content
            ref="selectableTable"
            :data="tableList"
            :option="tableOption"
            pagination
            :page.sync="page"
            :limit.sync="size"
            :pagination-props="{
              background: false,
              layout: `prev, pager, next`
            }"
            :total="total"
            selection
            table-id="id"
            :selected="selection"
            @select="handleSelect"
            @selectionChange="changeSelection"
            @select-all="handleSelectAll"
          />
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import listFilterMixin from '@/mixins/list-filter-mixin'
import {
  getCertificationCategoryApi,
  getCertificationListApi
} from '@/api/company/v1'
import { unique } from '@/utils/utils'

export default {
  mixins: [listFilterMixin],

  model: {
    prop: 'certList',
    event: 'change'
  },

  props: {
    // 证件列表
    certList: {
      type: Array,
      default: () => []
    },
    // key值转换
    props: {
      type: Object,
      default: () => ({
        id: 'id',
        name: 'name'
      })
    },
    // 数据转换出
    translateOutFn: {
      type: Function,
      default: undefined
    }
  },

  data() {
    return {
      visible: false, // 弹窗显示隐藏
      // 分类
      currentSortId: '',
      sortSearchText: '',
      sortList: [],

      // 证件列表
      filterForm: { name: '' },
      tableList: [],
      total: 0,
      size: 5,

      // 选中项
      tableOption: [
        {
          label: '证件名称',
          prop: 'name'
        }
      ],
      selection: []
    }
  },

  watch: {
    sortSearchText(val) {
      this.$refs.tree.filter(val)
    }
  },

  methods: {
    /**
     * 打开证件要求
     */
    openCertificateRequire() {
      const tempList = this.certList.map(el => ({
        ...el,
        id: el[this.props.id],
        name: el[this.props.name]
      }))
      this.open(tempList)
    },

    /**
     * 打开弹窗
     */
    async open(data) {
      this.selection = cloneDeep(data) || []
      await this.getCertificateSort()
      this.visible = true
      const _currentSort = this.sortList[0] || {}
      this.currentSortId = _currentSort.id ? `${_currentSort.id}` : ''
      this.currentSortId && this.getList()
    },

    /**
     * 获取证件分类
     */
    async getCertificateSort() {
      try {
        const _data = await getCertificationCategoryApi()
        this.sortList = _data.data || []
      } catch (err) {
        this.$message.error(err.message)
      }
    },

    /**
     * 过滤分类数据
     */
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },

    /**
     * 选中证件分类，获取当前分类
     */
    selectSort(data) {
      this.currentSortId = data.id
      this.getList()
    },

    /**
     * 获取选中项
     */
    changeSelection(selection) {
      // 在父组件内保存可选表格传出的选中项数据
      // this.selection = selection
      this.selection = this.selection.concat(selection)
      this.selection = unique(this.selection, 'id')
    },

    // 勾选行
    handleSelect(selection, row) {
      const haveRow = selection.some(item => item.id === row.id)
      if (!haveRow) {
        const rowIndex = this.selection.findIndex(item => item.id === row.id)
        this.selection.splice(rowIndex, 1)
      }
    },

    handleSelectAll(selection) {
      this.selection = selection
    },

    /**
     * 删除选中项
     */
    closeTag(index) {
      this.selection.splice(index, 1)
      this.$refs.selectableTable.clearSelection()
    },

    // 删除证件要求
    closeCertListTag(index) {
      const _cerList = cloneDeep(this.certList)
      _cerList.splice(index, 1)
      this.$emit('change', _cerList)
    },

    /**
     * 表单关闭
     */
    closeDialog() {
      this.visible = false
      this.selection = []
      this.page = 1
    },

    /**
     * 分页查询数据
     */
    async getList() {
      this.epitaxy()

      try {
        const _data = await getCertificationListApi({
          ...this.filterForm,
          page: this.page,
          size: this.size,
          parentId: this.currentSortId
        })
        this.tableList = _data.data.records || []
        this.total = _data.data.total
      } catch (err) {
        this.$message.error(err.message || '获取证件列表失败')
      }
    },

    /**
     * 确认选中数据
     */
    submit() {
      const _list = cloneDeep(this.selection)
      let list = []
      if (this.translateOutFn) {
        list = _list.map(el => {
          const _el = this.translateOutFn(el)
          return _el
        })
      } else {
        list = _list.map(el => ({
          ...el,
          [this.props.id]: el.id,
          [this.props.name]: el.name
        }))
      }
      this.$emit('change', list)
      this.closeDialog()
    }
  }
}
</script>

<style lang="scss" scoped>
.sort-container {
  position: relative;
  height: 380px;

  .content-left {
    position: absolute;
    width: 250px;
    height: calc(100% - 2.5rem);
    padding: 0 !important;

    .section-content {
      padding: 0 pixel-to-rem($n: 20);
    }
  }

  .content-right {
    margin-left: 280px;

    .filter-wrap {
      padding-top: 22px;
      padding-left: pixel-to-rem($n: 30);

      ::v-deep .el-button {
        width: pixel-to-rem($n: 160);
      }
    }

    .table-wrap {
      margin-top: pixel-to-rem($n: 20);

      .table-btn {
        padding: pixel-to-rem($n: 30);
        ::v-deep .el-button {
          width: pixel-to-rem($n: 160);
        }
      }
    }
  }
}

::v-deep {
  .el-tree {
    margin-top: pixel-to-rem(20);
    .active {
      color: $primary-color;
    }
  }
}
</style>
